import {Injectable} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {lastValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) {
  }

  async canActivate(): Promise<boolean> {
    if (this.authService.isLoggedIn) return true;
    // this.router.navigate(['/login']);
    try{
      const resp = await lastValueFrom(this.authService.refreshToken())
      if (resp.token) {
        this.authService.token = resp.token;
        this.authService.refreshTokenKey = resp.refreshToken;
        return true
      } else {
        this.router.navigate(['/login']);
      }
      return false;
    }catch (e){
      this.router.navigate(['/login']);
      return false;
    }
  }
}
